import { Checkbox } from 'antd'
import {
  CheckboxGroup,
  CheckboxWithCount,
  CountBadge,
  FilterSection,
  FilterTitle,
  LabelCell,
} from 'features/inbox/components/filters/filterElements'
import React, { memo, useCallback, useMemo } from 'react'
import { INSPECTION_TYPE_LABELS } from 'utils/inspectionTypes'

export type InspectionTypeFilterProps = {
  selectedTypeFilters: ReadonlyArray<string>
  countsByTypeKey: Readonly<Record<string, number>>
  onChange: (newFilters: ReadonlyArray<string>) => void
}

const InspectionTypeFilterComponent: React.FC<InspectionTypeFilterProps> = ({
  selectedTypeFilters,
  countsByTypeKey,
  onChange,
}) => {
  const handleToggle = useCallback(
    (checked: boolean, key: string) => {
      const currentFilters = selectedTypeFilters
      const next = checked
        ? [...currentFilters, key]
        : currentFilters.filter((type) => type !== key)
      onChange(next)
    },
    [onChange, selectedTypeFilters]
  )

  const typeEntries = useMemo(
    () =>
      Object.entries(countsByTypeKey)
        .filter(([, count]) => count > 0)
        .sort(([keyA], [keyB]) => {
          const labelA = INSPECTION_TYPE_LABELS[keyA] || keyA
          const labelB = INSPECTION_TYPE_LABELS[keyB] || keyB
          return labelA.localeCompare(labelB)
        }),
    [countsByTypeKey]
  )

  return (
    <FilterSection>
      <FilterTitle level={5}>Inspection Type</FilterTitle>
      <CheckboxGroup>
        {typeEntries.map(([key, count]) => (
          <CheckboxWithCount key={key}>
            <LabelCell>
              <Checkbox
                checked={selectedTypeFilters.includes(key)}
                onChange={(e) => handleToggle(e.target.checked, key)}>
                {INSPECTION_TYPE_LABELS[key] || key}
              </Checkbox>
            </LabelCell>
            <CountBadge>({count})</CountBadge>
          </CheckboxWithCount>
        ))}
      </CheckboxGroup>
    </FilterSection>
  )
}

export const InspectionTypeFilter = memo(InspectionTypeFilterComponent)
